import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

const UMAuthorityClubAccess = ({
  clubs,
  isScoped,
  loading,
  togglingClubId,
  searchTerm,
  onSearchChange,
  onToggleClub,
  allClubsAccess,
  togglingAllClubsAccess,
  onToggleAllClubsAccess,
}) => {
  const { t } = useTranslation(["staff", "common"]);

  const filteredClubs = useMemo(() => {
    const term = searchTerm.trim().toLowerCase();
    if (!term) return clubs;
    return clubs.filter((club) => (club.name || club.nameLocal || club.nameEn || "").toLowerCase().includes(term));
  }, [clubs, searchTerm]);

  const selectedCount = clubs.filter((club) => isScoped(club.id)).length;

  return (
    <div className="card border-0 shadow-sm">
      <div className="card-body">
        <div className="d-flex align-items-center justify-content-between mb-1">
          <h6 className="fw-bold mb-0">{t("staff:clubAccess.title")}</h6>
          {!allClubsAccess && (
            <span className="text-muted small">{t("staff:clubAccess.selectedCount", { count: selectedCount })}</span>
          )}
        </div>

        <div className="d-flex align-items-center justify-content-between border rounded-3 px-3 py-2 my-3 bg-light">
          <div className="me-3">
            <label className="form-check-label fw-semibold mb-0" htmlFor="allClubsAccessSwitch">
              {t("staff:clubAccess.allClubsAccess.label")}
            </label>
            <div className="text-muted small">{t("staff:clubAccess.allClubsAccess.hint")}</div>
          </div>
          <div className="form-check form-switch mb-0 flex-shrink-0">
            <input
              type="checkbox"
              role="switch"
              className="form-check-input"
              id="allClubsAccessSwitch"
              checked={!!allClubsAccess}
              disabled={togglingAllClubsAccess}
              onChange={(e) => onToggleAllClubsAccess(e.target.checked)}
            />
          </div>
        </div>

        {allClubsAccess ? (
          <div className="alert alert-info d-flex align-items-center mb-0">
            <i className="fas fa-circle-check me-2"></i>
            {t("staff:clubAccess.allClubsAccess.badge")}
          </div>
        ) : loading ? (
          <div className="text-center py-3">
            <div className="spinner-border spinner-border-sm text-primary" role="status"></div>
          </div>
        ) : clubs.length === 0 ? (
          <p className="text-muted mb-0">{t("staff:clubAccess.empty")}</p>
        ) : (
          <>
            <div className="input-group input-group-sm my-3">
              <span className="input-group-text bg-white border-end-0">
                <i className="fas fa-search text-muted"></i>
              </span>
              <input
                type="text"
                className="form-control border-start-0"
                placeholder={t("staff:clubAccess.searchPlaceholder")}
                value={searchTerm}
                onChange={(e) => onSearchChange(e.target.value)}
              />
            </div>

            {filteredClubs.length === 0 ? (
              <p className="text-muted small mb-0">{t("staff:clubAccess.noSearchResults")}</p>
            ) : (
              <div className="authority-club-pill-grid">
                {filteredClubs.map((club) => {
                  const selected = isScoped(club.id);
                  return (
                    <button
                      key={club.id}
                      type="button"
                      className={`authority-club-pill ${selected ? "selected" : ""}`}
                      disabled={togglingClubId === club.id}
                      onClick={() => onToggleClub(club)}
                    >
                      {togglingClubId === club.id ? (
                        <span className="spinner-border spinner-border-sm me-1" role="status"></span>
                      ) : (
                        <i className={`fas ${selected ? "fa-circle-check" : "fa-circle"} me-1`}></i>
                      )}
                      {club.name || club.nameLocal || club.nameEn}
                    </button>
                  );
                })}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default UMAuthorityClubAccess;
